<template>
  <div class="container is-gap-top">
    <!-- <div>
      External:
    </div> -->
    <div id="BambooHR"
      data-domain="alliedinstructionalservices.bamboohr.com"
      data-version="1.0.0"
      data-departmentId="">
    </div>
    <div id="ExternalBambooHR"></div>
  </div>
</template>

<script>
// import _ from 'lodash'
import Util from '@/util'
// import Site from '@/apis/site'
// import EventBus from '@/controllers/EventBus'

export default {
  name: 'page-opportunities',
  props: {
    // msg: String
  },
  components: {
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    Util: function () {
      return Util
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    // this.load()
    // this.dispatchEvent()
    this.loadManual()
  },
  methods: {
    load () {
      (function (d, s, id, idjs) {
        console.log('-- start embed')
        var parent = d.getElementById(id)
        var js
        let child = d.getElementById(idjs)
        if (child) {
          console.log('-- exist embed')
          parent.removeChild(child)
        }
        js = d.createElement(s)
        js.id = idjs
        js.setAttribute('src', 'https://alliedinstructionalservices.bamboohr.com/js/embed.js')
        js.setAttribute('type', 'text/javascript')
        js.setAttribute('async', '')
        js.setAttribute('defer', '')
        parent.appendChild(js)
        console.log('-- ended embed')
      }(document, 'script', 'ExternalBambooHR', 'ExternalBambooHRJS'))
    },

    dispatchEvent () {
      const event = document.createEvent('Event')
      event.initEvent('readystatechange', true, true)
      document.addEventListener('readystatechange', function (event) {
        console.log('-- event changed', event)
        if (event.target.readyState === 'complete') {
        }
      })
      document.dispatchEvent(event)
    },

    loadManual () {
      /**
       * Embed Careers Page
       * BambooHR Version 1.0.0
       */
      const _load = () => {
        var rootId = 'BambooHR-ATS'
        var el = document.getElementById('BambooHR')

        if (!el) {
          console.error('BambooHR-ATS: Hmm, Looks like we are missing something, Double check the code snippet.')
          return
        }

        var departmentId = el.getAttribute('data-departmentId')
        var domain = el.getAttribute('data-domain')
        var version = el.getAttribute('data-version') || '1.0.0'

        if (!domain) {
          console.error('BambooHR-ATS: We are unable to retrieve the domain, Double check the code snippet.')
          return
        }

        var root = document.createElement('div')
        root.id = rootId
        el.appendChild(root)

        var footer = document.createElement('div')
        footer.style = 'font-family: "Lato", sans-serif; font-size: 12px; color: #999; text-align: right; margin: 9px 9px 0px 0px;'
        var poweredBy = document.createTextNode('Powered by')
        var logo = document.createElement('img')
        logo.src = 'https://resources.bamboohr.com/images/footer-logo.png'
        logo.alt = 'BambooHR - HR software'
        logo.style = 'display:inline;'
        var link = document.createElement('a')
        link.href = 'http://www.bamboohr.com'
        link.target = '_blank'
        link.rel = 'external'

        link.appendChild(logo)
        footer.appendChild(poweredBy)
        footer.appendChild(link)

        el.appendChild(footer)

        var embedUrl = 'https://' + domain + '/jobs/embed2.php?version=' + encodeURIComponent(version) + ''

        if (departmentId) {
          embedUrl += '&departmentId=' + encodeURIComponent(departmentId)
        }

        var xmlhttp = new XMLHttpRequest()
        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
            var content = xmlhttp.responseText
            if (root) root.innerHTML = content
          }
        }
        xmlhttp.open('GET', embedUrl, true)
        xmlhttp.send()
      }
      _load()
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-opportunities {
  .rounded-wrapper {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: lightgray;
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
}

</style>
